import {
  SET_CURRENT_USER,
  SET_TABLES,
  SET_GLOBAL_CHAT,
  SET_TABLE_CHAT,
  SET_RECENT_GAMES,
  SET_CONFIG,
  SET_TOP_EARNERS,
  SET_TOP_WINNERS,
  SET_ACTIVE_USERS,
  RESET_APP,
} from './types';

export const setCurrentUser = user => ({
  type: SET_CURRENT_USER,
  payload: user,
});

export const setTables = tables => ({
  type: SET_TABLES,
  payload: tables,
});

export const setGlobalChat = chats => ({
  type: SET_GLOBAL_CHAT,
  payload: chats,
});

export const setTableChat = chats => ({
  type: SET_TABLE_CHAT,
  payload: chats,
});

export const setRecentGames = games => ({
  type: SET_RECENT_GAMES,
  payload: games,
});

export const setConfig = config => ({
  type: SET_CONFIG,
  payload: config,
});

export const setTopEarners = topEarners => ({
  type: SET_TOP_EARNERS,
  payload: topEarners,
});

export const setTopWinners = topWinners => ({
  type: SET_TOP_WINNERS,
  payload: topWinners,
});

export const setActiveUsers = activeUsers => ({
  type: SET_ACTIVE_USERS,
  payload: activeUsers,
});

export const resetApp = () => ({
  type: RESET_APP,
});
